module.exports = __webpack_public_path__ + "assets_app/img/key-7.d2c75c80.svg";